module.exports = "https://cdn.realtymogul.com/static/media/icon_expand_wht.38efb120.svg";